import Service from "../Service";
const resource = "PrfOrdersProjection/";

export default {
    pagination(obj, requestID) {
        return Service.post(
            resource+"paginationOrders", 
            obj,
            {
                params: { requestID: requestID }
            }
        );
    },
    getCertificates(obj, requestID) {
        return Service.post(
            resource+"getCertificate",
            obj,
            {
                params: { requestID: requestID }
            }
        );
    },
    save(spo, requestID) {
        return Service.post(
            resource+"save", 
            spo, 
            {
                params: { requestID: requestID }
            }
        );
    },
}
